import React, { Component, Fragment, createRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createSelectorCreator, defaultMemoize } from 'reselect'
import Modal from '@app/components/ui/modals/Modal'
import _ from 'lodash'
import { ActionTypes } from '@app/constants'
import * as apiActions from '@app/actions/api'
import { honeybadger } from '@app/honeybadger'

const apiSelector = state => state.api

const equalSelector = createSelectorCreator(defaultMemoize, _.isEqual)

const boundarySelector = equalSelector(
  [ apiSelector],
  (api) => { return { api } }
)

const mapStateToProps = (state) => boundarySelector(state)

const mapDispatchToProps = (dispatch) => {
  return { boundApiActions: bindActionCreators(apiActions, dispatch) }
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.errorPresenter = createRef(null);
    this.state = { hasError: false, error: null };
    this._networkErrorTimer = null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.api.error || this.state.hasError) {
      const { errorType } = this.props.api

      if (errorType === ActionTypes.ACCESS_DENIED) {
        window.location.reload()
      }
      else if (errorType === ActionTypes.NETWORK_ERROR) {
        if (this._networkErrorTimer) { clearTimeout(this._networkErrorTimer) }
        this._networkErrorTimer = setTimeout(() => {
          const { api: { errorType: currentType } } = this.props
          if (currentType === ActionTypes.NETWORK_ERROR) {
            this.errorPresenter.current.open()
          }
        }, 700)
      }
      else {
        this.errorPresenter.current.open()
      }
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    honeybadger.notify(error, errorInfo)
  }

  get errorMessage() {
    const { api: { errorType } } = this.props

    // API_ERROR:
    // ACCESS_DENIED:
    // NETWORK_ERROR:

    switch (errorType) {
    case ActionTypes.NETWORK_ERROR:
      return I18n.t('error_pages.no_connection')
    default:
      return I18n.t('error_pages.page_500.error_message')
    }
  }

  reloadPage() {
    window.location.reload()
  }

  presentError() {
    return (
      <Modal ref={this.errorPresenter}>
        <div className="text-center">
          { this.errorMessage }
          <div className="mt-2 text-center">
            <button className="btn btn--red" onClick={this.reloadPage}>
              { I18n.t('error_pages.reload_page') }
            </button>
          </div>
        </div>
      </Modal>
    )
  }

  render() {
    const { api: { error } } = this.props
    const { hasError } = this.state
    return (
      <Fragment>
        { error || hasError ? this.presentError() : null }
        { !hasError ? this.props.children : null }
      </Fragment>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary)
